// src/theme/tokens.js
export const tokens = {
  accent: {
      /*  main: "#7AA2FF",*/
        main: "#3f51b5",
    soft: "rgba(122, 162, 255, 0.18)",
  },
    
  dark: {
    bg: "#0B0C0F",
    paper: "#101217",
    elevated: "#151824",

    border: "rgba(255,255,255,0.12)",

    textPrimary: "rgba(255,255,255,0.92)",
    textSecondary: "rgba(255,255,255,0.68)",
    textDisabled: "rgba(255,255,255,0.38)",

    hover: "rgba(255,255,255,0.06)",
    selected: "rgba(122,162,255,0.18)",

    glass: {
      surface: "rgba(16, 18, 23, 0.72)",
      border: "rgba(255,255,255,0.10)",
      strongSurface: "rgba(16, 18, 23, 0.86)",
    },

    scrim: "rgba(0,0,0,0.55)",
  },

  light: {
    bg: "#F6F7F9",
    paper: "#FFFFFF",
    elevated: "#FFFFFF",

    border: "rgba(0,0,0,0.12)",

    textPrimary: "rgba(0,0,0,0.88)",
    textSecondary: "rgba(0,0,0,0.62)",
    textDisabled: "rgba(0,0,0,0.38)",

    hover: "rgba(0,0,0,0.06)",
    selected: "rgba(122,162,255,0.14)",

    glass: {
      surface: "rgba(255, 255, 255, 0.72)",
      border: "rgba(0,0,0,0.10)",
      strongSurface: "rgba(255, 255, 255, 0.88)",
    },

    scrim: "rgba(0,0,0,0.35)",
  },
};
